import { cn } from "@/shared/lib/cn";

/** 内联加载指示 */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-block size-4 animate-spin rounded-full border-2 border-fg-subtle border-t-brand",
        className,
      )}
      role="status"
      aria-label="加载中"
    />
  );
}
